import React from 'react'
import AppRoutes from './AppRoutes'
import { Row } from 'antd'

export default function ContentBody() {

    return (

        <div>
          
            <AppRoutes />

        </div>

    )
}
